export enum ProductStatusDistributionEnum {
    Done = 'E',
    DevolutionTotal = 'DT',
    DevolutionPartial = 'DP'
}
